import { countryService } from '@/services/country.service'
import Vue from 'vue'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";
import { TIME_ZONES_AND_COUNTRIES } from '@/constants/constants';

export default {
    name: 'EnterpriseAddressTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        },
        update: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // selector de países
        countries: [],
        // selector de provincias
        provinces: [],
        // selector de ciudades
        cities: [],
        // selector de zona horaria
        timeZones: TIME_ZONES_AND_COUNTRIES,
        // model para el formulario
        isValidForm: false,
        // loading selectores
        loadingCountries: false,
        loadingProvinces: false,
        loadingCities: false,
        // para saber si se deben cargar los selectores de provincia ciudad en el update
        initUpdate: false
    }),
    computed: {
    },
    created() {
        this.initUpdate = this.update
        if (this.initUpdate) {
            this.initSelectors()
        } else {
            this.getCountries()
        }
    },
    mounted() {
    },
    methods: {
        /**
         * Carga los países en el selector
         */
        async getCountries() {
            this.loadingCountries = true
            this.countries = await countryService.getCountries()
            this.loadingCountries = false
        },
        /**
         * Carga las provincias/estados en el selector
         * @param {*} countryId
         */
        async getProvinces(countryId) {
            this.loadingProvinces = true
            const country_id = this.countries.find(country => country._id === countryId).id
            this.provinces = await countryService.getProvinces(country_id)
            this.loadingProvinces = false
        },
        /**
         * Carga las ciudades en el selector
         * @param {*} countryId
         * @param {*} provinceId
         */
        async getCities(countryId, provinceId) {
            this.loadingCities = true
            const country_id = this.countries.find(country => country._id === countryId).id
            const state_id = this.provinces.find(province => province._id === provinceId).id
            this.cities = await countryService.getCities(country_id, state_id)
            this.loadingCities = false
        },
        /**
         * Para inicializar los selectores en la actualización
         */
        async initSelectors() {
            await this.getCountries()
            if (this.model.countryId) {
                await this.getProvinces(this.model.countryId)
            }
            if (this.model.countryId && this.model.cityId) {
                await this.getCities(this.model.countryId, this.model.provinceId)
            }
            const that = this
            Vue.nextTick(function () {
                that.initUpdate = false
            })
        },
        /**
         * Cada vez que se modifica la selección del pais, se cargan
         */
        countrySelectedFunction(newValue) {
            this.model.countryId = newValue._id ? newValue._id : newValue;
        },
        /**
         * Cada vez que se modifica la selección de la provincia, se cargan
         */
        provinceSelectedFunction(newValue) {
            this.model.provinceId = newValue._id ? newValue._id : newValue;
        },
        /**
         * Cada vez que se modifica la selección de la ciudad, se cargan
         */
        citySelectedFunction(newValue) {
            this.model.cityId = newValue._id ? newValue._id : newValue;
        },
        timezoneSelectedFunction(newValue) {
            this.model.timezoneId = newValue.id
            this.model.timezone = Number.parseFloat(newValue.timeZone)
        }
    },
    watch: {
        isValidForm(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('update:validForm', newVal)
            }
        },
        'model.countryId': {
            handler: async function (val) {
                if (!this.initUpdate) {
                    if (val) {
                        await this.getProvinces(val)
                    } else {
                        this.provinces = []
                    }
                    if (!this.provinces.find(province => province._id === this.model.provinceId)) {
                        this.model.provinceId = null
                        this.cities = []
                        this.model.cityId = null
                    }
                }
            },
            deep: true
        },
        'model.provinceId': {
            handler: async function (val) {
                if (!this.initUpdate) {
                    if (val) {
                        await this.getCities(this.model.countryId, val)
                    } else {
                        this.cities = []
                    }
                    if (!this.cities.find(city => city._id === this.model.cityId)) {
                        this.model.cityId = null
                    }
                }
            },
            deep: true
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.enterpriseAddressForm) {
                this.$refs.enterpriseAddressForm.resetValidation()
            }
        }
    }
}
